import { Button, Dropdown, Flex, Input, Modal } from "antd"
import { useState } from "react";

const FilterInfoModal = ({isOpen = true, handleCancel=()=>{}, onSearch = ()=>{}}) => {
    const [inputValue, setInputValue] = useState("");

    const handleSearchClick = () => {
        onSearch(inputValue);
    };

    const onReset = () => {
        setInputValue("");
        onSearch("-1");
    }

    return (<Modal
        width={680}
        title="Filter Info Proxy"
        open={isOpen}
        onCancel={handleCancel}
        footer={<></>}
    >
        <Flex justify="space-between" className="pb-2">
            <p>Tìm Kiếm</p>
            <div>
                <Button style={{marginRight: 8}} onClick={onReset}>
                    Reset
                </Button>
                <Button type="primary" onClick={handleSearchClick}>
                    Tìm kiếm 🔎
                </Button>
            </div>
        </Flex>
        <Input.TextArea
            rows={10}
            // placeholder="IP:PORT:USERNAME:PASSWORD"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
        />
    </Modal>)
}

export default FilterInfoModal